import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MessageService } from 'primeng/api';

import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { ApiModule } from './core/api/api.module';
import { StaffModule } from './staff/staff.module';
import { SupervisorModule } from './supervisor/supervisor.module';
import { GraphsModule } from './graphs/graphs.module';
import { SettingsModule } from './settings/settings.module';
import { OfflineModule } from './offline/offline.module';
import { PatientSessionService } from './staff/home/patient-session.service';
import { SelectPatientComponent } from './select-patient.component';
import { UserNotAuthorizedComponent } from './user-not-authorized.component';

@NgModule({ declarations: [AppComponent, SelectPatientComponent, UserNotAuthorizedComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        //ApiModule,
        ApiModule.forRoot({
            rootUrl: environment.webApiRoot,
        }),
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true,
            registrationStrategy: 'registerImmediately',
        }),
        CoreModule.forRoot(),
        StaffModule,
        SupervisorModule,
        GraphsModule,
        SettingsModule,
        OfflineModule], providers: [
        MessageService,
        PatientSessionService,
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: 'none'
                }
            }
        }),
    ] })
export class AppModule { }
